import React, { useState, useEffect } from 'react';
import { ContextBar } from '../components/layout/ContextBar';
import { Header } from '../components/layout/Header';
import { FilmGrainOverlay } from '../components/effects/FilmGrainOverlay';
import { SilkFlowBackground } from '../components/effects/SilkFlowBackground';
import { FloatingBottomDock } from '../components/layout/FloatingBottomDock';
import { CookieConsentManager } from '../components/layout/CookieConsentManager';
import { VaultHandshakeModal } from '../components/intake/VaultHandshakeModal';
import { useForensicsTracker } from '../lib/useForensicsTracker';
import { SmartToast } from '../components/layout/SmartToast';

export interface RootLayoutProps {
  children: React.ReactNode;
}

export function RootLayout({ children }: RootLayoutProps) {
  const [isVaultModalOpen, setIsVaultModalOpen] = useState(false);
  const [vaultInitialStep, setVaultInitialStep] = useState(1);

  // Initialize client passive forensics telemetry engine
  useForensicsTracker();

  useEffect(() => {
    const handleOpenVault = (e: any) => {
      if (e.detail?.step) {
        setVaultInitialStep(e.detail.step);
      } else {
        setVaultInitialStep(1);
      }
      setIsVaultModalOpen(true);
    };

    window.addEventListener('sp_open_vault_handshake', handleOpenVault);
    return () => window.removeEventListener('sp_open_vault_handshake', handleOpenVault);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] text-[#141416] flex flex-col antialiased selection:bg-[#8C6D37]/20 selection:text-[#141416] relative">
      {/* 2026 Silk Flow Background: Легкое колыхание шелка на 3-4 микро-тона */}
      <SilkFlowBackground />

      {/* 2026 CSS Film Grain & Micro-Noise Overlay (Швейцарская полиграфия) */}
      <FilmGrainOverlay />
      
      <Header />
      <main id="main-content" className="flex-1 w-full relative z-10">
        {children}
      </main>
      
      {/* 2026 FLOATING LIQUID GLASS DOCK (НИЖНИЙ НАВИГАЦИОННЫЙ БАР) */}
      <FloatingBottomDock />

      {/* ТЕЛЕМЕТРИЧЕСКИЙ БАР В САМОМ НИЗУ (BOTTOM TERMINAL DOCK) */}
      <ContextBar />

      {/* ПЛАШКА О СБОРЕ COOKIE (152-ФЗ) - ПОЯВЛЯЕТСЯ 1 РАЗ */}
      <CookieConsentManager />

      {/* S&P RECON-PIPELINE: INSTITUTIONAL ZERO-PARTY INTAKE SHIELD & MODAL */}
      <VaultHandshakeModal
        isOpen={isVaultModalOpen}
        onClose={() => setIsVaultModalOpen(false)}
        defaultStep={vaultInitialStep}
      />

      <SmartToast />
    </div>
  );
}

export default RootLayout;
